<template>
  <v-container
    fluid
    :class="{
      'px-0': !packageMode,
      'py-0': !packageMode,
      block: packageMode,
      isBlocked: !editMode,
    }"
  >
    <v-layout row wrap>
      <v-flex xs12 owners>
        <v-layout row wrap v-if="!facesData || !facesData.length">
          <v-flex xs12>
            <h2 class="empty_title">{{$t('components.clients.faces.emptyTitle')}}</h2>
          </v-flex>
        </v-layout>
        <v-layout row wrap v-else>
          <v-flex xs12>
            <table v-if="facesData.length">
              <tr>
                <th>{{$t('components.clients.faces.table.typeFace')}}</th>
                <th>{{$t('components.clients.faces.table.fullName')}}</th>
                <th></th>
              </tr>
              <tr v-for="(item, idx) in facesData" :key="idx" class="item-name">
                <td @click="editFace(item)">{{ getFaceTypeName(item) }}</td>
                <td @click="editFace(item)">
                  {{ item.surname }} {{ item.name }} {{ item.patronymic }}
                </td>

                <td class="table-actions">
                  <div class="table-actions__buttons text-right">
                    <v-btn
                      text
                      icon
                      @click="editFace(item)"
                      :disabled="!editMode"
                      class="ma-0 pa-0"
                    >
                      <v-icon color="warning" size="20px">edit</v-icon>
                    </v-btn>

                    <delete-dialog
                      :deleteButton="{
                        type: 'icon',
                        value: 'delete',
                        disabled: !editMode,
                        iconColor: 'error',
                      }"
                      :item-name="item.name"
                      v-on:deleteEntry="deleteEntry(item)"
                    />
                  </div>
                </td>
              </tr>
            </table>
          </v-flex>
        </v-layout>
        <span
          @click="createNewFace"
          class="add-link"
          v-if="!packageMode || editMode"
        >
          <v-icon>add</v-icon>{{$t('components.clients.faces.addFaceBtn')}}
        </span>
      </v-flex>

      <v-dialog
        v-model="createFace"
        transition="slide-x-reverse-transition"
        content-class="halfscreen"
        persistent
      >
        <add-face
          v-on:addFace="addFace"
          v-on:updateFaces="updateFaces"
          v-on:updateFacesAndFounders="updateFacesAndFounders"
          v-on:closeModal="closeModal"
          :edited-face="face"
          :create="create"
          :ceo="ceo"
          :editMode="editMode"
          :packageMode="packageMode"
          :agentMode="agentMode"
          :publicHash="publicHash"
          :client-company="clientCompany"
          v-if="face && createFace"
        />
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
import AddFace from "@/components/clients/add/face";
import { apiCallTrue } from "@/utils/api";
import DeleteDialog from "@/components/lib/DeleteDialog";
import i18n from "@/services/i18n";

export default {
  name: "ClientFaces",
  data() {
    return {
      createFace: false,
      valid: false,
      face: null,
      create: null,
    };
  },
  props: {
    publicHash: {
      type: String,
      default: "",
    },
    facesData: {
      type: Array,
    },
    ceo: {
      type: String,
    },
    packageMode: {
      type: Boolean,
      default: false,
    },
    editMode: {
      type: Boolean,
      default: false,
    },
    agentMode: {
      type: Number,
      default: 0,
    },
    clientCompany: {
      type: Object,
      default: null,
    }
    // modalMode: {
    //     type: Boolean,
    //     default: false
    // }
  },
  components: {
    AddFace,
    DeleteDialog,
  },
  methods: {
    getFaceTypeName(item) {
      let defName = i18n.t('components.clients.faces.faceTypeName.default');
      if (item.inn && new String(item.inn).length == 12) {
        defName = i18n.t('components.clients.faces.faceTypeName.1');
      }
      const names = {
        1: defName,
        2: i18n.t('components.clients.faces.faceTypeName.2'),
      };
      return names[item.type];
    },
    addFace(face) {
      console.log("in add face", face);
      this.$emit("addFace", face);
      this.createFace = false;
      this.face = null;
      this.create = null;
    },
    updateFaces(face) {
      console.log("in upd face", face);
      this.$emit("updateFaces", face);
      this.createFace = false;
      this.face = null;
      this.create = null;
    },
    updateFacesAndFounders() {
      console.log("in add face & found");
      this.$emit("updateFacesAndFounders");
      this.createFace = false;
      this.face = null;
      this.create = null;
    },
    createNewFace() {
      this.create = true;
      this.face = {};
      this.createFace = true;
    },
    editFace(face) {
      this.create = false;
      this.face = Object.assign({}, face);
      this.createFace = true;
    },
    openFace(face) {
      this.create = false;
      this.face = Object.assign({}, face);
      this.createFace = true;
    },
    closeModal() {
      this.create = null;
      this.createFace = false;
    },
    async deleteEntry(item) {
      const index = this.facesData.indexOf(item);

      const url = this.publicHash
        ? `v1/officials/${item.id}/delete-by-hash/${this.publicHash}`
        : `v1/officials/${item.id}/delete`;

      if (this.packageMode && !this.publicHash) {
        this.facesData.splice(index, 1);
      } else {
        await apiCallTrue({
          url,
          method: "POST",
        })
          .then(() => {
            this.facesData.splice(index, 1);
          })
          .catch(() => console.log("not deleted"));
      }
    },
  },
};
</script>

<style scoped>
#app .v-menu__content {
  box-shadow: 0 0 0;
}
</style>
